module.exports = __webpack_public_path__ + "media/images/icon__xco--rb-gray@3x-4f5fe624e0a0cadd2c4d594b8241db5e.png";